import { render, staticRenderFns } from "./RegisterPage.vue?vue&type=template&id=aaede46c&scoped=true&"
import script from "./RegisterPage.vue?vue&type=script&lang=js&"
export * from "./RegisterPage.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPage.vue?vue&type=style&index=0&id=aaede46c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaede46c",
  null
  
)

export default component.exports